/* gkg Journey-Tracking 28.09.2026 (Claude)
 *
 * Ergaenzt die vom Shopify-Web-Pixel (Google & YouTube) gesendeten
 * GA4-Events um das fehlende Stueck der Customer Journey:
 *
 *  - select_item     Klick auf eine Produktkachel (Impression -> Klick,
 *                    Basis fuer die Klickrate im CRM-Journey-Bereich).
 *                    item_id im selben Format wie das Web-Pixel
 *                    ("shopify_US_<productId>_<variantId>"), damit die
 *                    CRM-Auswertung beides demselben Produkt zuordnet.
 *  - gkg_size_select Groessenwahl auf der Produktseite.
 *
 * Bewusst leichtgewichtig: keine Bibliothek, nur delegierte Listener,
 * gtag mit transport beacon (ueberlebt den Seitenwechsel). Ohne gtag
 * (Blocker) passiert schlicht nichts. KEINE SKU im Tracking.
 */
(function () {
  'use strict';

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        params = params || {};
        params.transport_type = 'beacon';
        window.gtag('event', name, params);
      }
    } catch (e) { /* Tracking darf nie den Shop stoeren */ }
  }

  /* Kachel-Klick -> select_item (Capture-Phase, damit es vor der
     Navigation sicher abgesetzt wird) */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href*="/products/"]');
    if (!a) return;
    var card = a.closest('[data-gkg-pid]');
    if (!card) return;
    var idx = 0;
    try {
      var cards = document.querySelectorAll('[data-gkg-pid]');
      idx = Array.prototype.indexOf.call(cards, card) + 1;
    } catch (err) { idx = 0; }
    track('select_item', {
      item_list_name: card.getAttribute('data-gkg-list') || '',
      items: [{
        item_id: card.getAttribute('data-gkg-item') || '',
        item_name: card.getAttribute('data-gkg-title') || '',
        item_brand: card.getAttribute('data-gkg-brand') || '',
        index: idx
      }]
    });
  }, true);

  /* Groessenwahl (Variantenwahl) auf der Produktseite */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.name === 'quantity') return;
    if (!t.closest('variant-selects, variant-radios')) return;
    var val = t.value;
    if (val == null && t.selectedOptions && t.selectedOptions[0]) {
      val = t.selectedOptions[0].value;
    }
    if (val == null || val === '') return;
    track('gkg_size_select', {
      size: String(val).slice(0, 20),
      page_path: location.pathname
    });
  }, true);
})();
